import $ from 'jquery';
import { scrollToElement } from './scroll';

$(document).on('shown.bs.collapse', ({ target }) => scrollToElement(target, 159));

export function expandAccordion(element) {
    $(element).collapse('show');
}
